(() => {
    const click = (e) => {
        // Clicked on .prebook-modal-toggle.
        if (e.target.classList.contains('prebook-modal-toggle')) {
            e.preventDefault()
            const modal = e.target.nextElementSibling
            modal && modal.classList.toggle('hidden')
        }

        // Clicked on .prebook-modal but not on .prebook-modal-body.
        if (e.target.classList.contains('prebook-modal') && !e.target.classList.contains('prebook-modal-body')) {
            e.target.classList.add('hidden')
        }
    }
    document.addEventListener('click', click)

    const keydown = (e) => {
        if (e.key === 'Escape') {
            const modals = document.querySelectorAll('.prebook-modal')
            modals && modals.forEach(modal => {
                modal.classList.add('hidden')
            })
        }
    }
    document.addEventListener('keydown', keydown)

})()